import { EVENT_FIELDS } from "../../constants/analytics.es.js";
const extractMetaTags = (payload) => {
  var _a;
  return {
    [EVENT_FIELDS.META_TITLE]: (_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.title
  };
};
export {
  extractMetaTags
};
